module.exports = __webpack_public_path__ + "img/qanda02.2066556.jpg";